import { useEffect, useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

Modal.setAppElement("#root");

const AddressModal = ({ isOpen, onClose,deliveryDate, selectedBabies,currentStep = 2, totalSteps = 4 }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem('AccessToken');
  const [address, setAddress] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [updatedAddress, setUpdatedAddress] = useState("");
  const [error, setError] = useState(false);
  const userInfo = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";


  useEffect(() => {
    const fetchAddress = async () => {
      try {
        const params = {
          Email: userInfo.userData.EmailID,
          DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
          memberID: userInfo.userData.MemberID,
          contract: userInfo.userData.ContractIdentified,
        };

        const response = await axios.post(
          Endpoints.VerifyWINOnesieGiftBoxAddress,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              "Authorization": `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setAddress(response.data.address);
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    };

    fetchAddress();
  }, [userInfo.userData.EmailID, token]);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setError(false);
  };

  const handleAddressChange = (event) => {
    setUpdatedAddress(event.target.value);
  };

  const handleNext = () => {
    let validationError = false;
  
    // No option selected
    if (!selectedOption) {
      setError(true);
      validationError = true;
    }
  
    // If "No" is selected but address is empty
    if (selectedOption === "No" && !updatedAddress.trim()) {
      setError(true);
      validationError = true;
    }
  
    if (validationError) return;
  
    const WINOnesieGift = selectedOption === "Yes" ? "Y" : selectedOption === "No" ? "Y" : "N";
    const finalAddress = selectedOption === "No" ? updatedAddress : address;
  
    navigate("/fourth-trimester-delivery-details", {
      state: {
        deliveryDate,
        Address: finalAddress,
        WINOnesieGift,
        step: 3,
        totalSteps,
        numberOfBabies: selectedBabies,
      },
    });
  
    onClose(); // Close the modal
  };
  
  // const handleNext = () => {
  //   if (!selectedOption) {
  //     setError(true);
  //     return;
  //   }

  //   const WINOnesieGift = selectedOption === "Yes" ? "Y" : selectedOption === "No" ? "Y" : "N";
  //   const finalAddress = selectedOption === "No" ? updatedAddress : address;

  //   navigate("/fourth-trimester-delivery-details", {
  //     state: {
  //       Address: finalAddress,
  //       WINOnesieGift,
  //       numberOfBabies: selectedBabies,
  //     },
  //   });

  //   onClose(); // Close the modal
  // };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="tracker-modal-content" overlayClassName="modal-overlay">
      <h2>Congratulations! We would love to send you a WIN onesie as our gift to you! Feel free to share cute baby pics in the WIN onesie with us or on your social media using <strong>#WIN</strong>.</h2>
      <p className="text-sm text-gray-600 mt-4">Is this address the best one to send it to?</p>

      <p><strong>{address}</strong></p>

      <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
        <input
          type="radio"
          id="optionYes"
          name="addressOption"
          value="Yes"
          className="form-check-input radio-btn win-form-check-input"
          onChange={handleOptionChange}
          checked={selectedOption === "Yes"}
        />
        <label className="multistep-form-radio-checkbox-label" htmlFor="optionYes">
          {t("yesradio")}
        </label>
      </div>

      <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
        <input
          type="radio"
          id="optionNo"
          name="addressOption"
          value="No"
          className="form-check-input radio-btn win-form-check-input"
          onChange={handleOptionChange}
          checked={selectedOption === "No"}
        />
        <label className="multistep-form-radio-checkbox-label" htmlFor="optionNo">
          {t("noradio")}
        </label>
      </div>

      <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
        <input
          type="radio"
          id="optionLater"
          name="addressOption"
          value="Later"
          className="form-check-input radio-btn win-form-check-input"
          onChange={handleOptionChange}
          checked={selectedOption === "Later"}
        />
        <label className="multistep-form-radio-checkbox-label" htmlFor="optionLater">
          {t("noneradio")}
        </label>
      </div>

      {selectedOption === "No" && (
        <div className="mt-3">
          <label className="form-label" htmlFor="updatedAddress">
            Please enter your address
          </label>
          <textarea
            id="updatedAddress"
            className="win-form-control textarea-control-w-100"
            rows="3"
            maxLength={250}
            value={updatedAddress}
            onChange={handleAddressChange}
          />
          {!updatedAddress && error && <p className="text-danger">{"Address is required if 'No' is selected."}</p>}
        </div>
      )}
      {!selectedOption && error && <p className="text-danger">{"Please select an address option."}</p>}
      <div className="d-flex justify-content-center align-items-center mt-4">
        <button onClick={handleNext} className="win-btn-primary mt-4">
          Next
        </button>
      </div>
    </Modal>
  );
};

export default AddressModal;
